import { GoabButton } from "@abgov/react-components";

import { useGenerationForm } from "../../hooks";

export const SubmitButton = () => {
  const { form, disableGeneration, setDisableGeneration } = useGenerationForm();

  return (
    <>
      <GoabButton
        mb="m"
        onClick={async () => {
          if (await form.validateForm()) {
            form.handleSubmit();
            setDisableGeneration(true);
          }
        }}
        disabled={Object.keys(form.errors).length > 0 || disableGeneration}
      >
        Generate application code
      </GoabButton>
    </>
  );
};
